<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 18.0961V5.90405L18.0768 12.0001L8.5 18.0961Z" fill="currentColor"/>
</svg>
